module.exports = __webpack_public_path__ + "static/img/Errol-Gulden.23164b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Errol-Gulden.jpg
// module id = etwZ
// module chunks = 0